import Bottle from 'bottlejs';
import spottingGroupContainerFactory from './SpottingGroupContainer';
import spottingGroupViewFactory from './SpottingGroupView';
import spottingGroupData from './SpottingGroupData';
import spottingGroupAddGroupContainerFactory from './SpottingGroupAddGroupContainer';
import groupAddHelp from './SpottingGroupAddHelp';
import spottingGroupConstants from './SpottingGroupConstants';

export default () => {
  const spottingGroupBottle = new Bottle();
  spottingGroupAddGroupContainerFactory(spottingGroupBottle);
  spottingGroupConstants(spottingGroupBottle);
  spottingGroupContainerFactory(spottingGroupBottle);
  spottingGroupViewFactory(spottingGroupBottle);
  spottingGroupData(spottingGroupBottle);
  groupAddHelp(spottingGroupBottle);
  return spottingGroupBottle;
};
